import { Link } from 'react-router-dom';
import { NavLink } from '@/components/NavLink';
import { Facebook, Instagram } from 'lucide-react';

const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61579672283759';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';

interface MobileMenuProps {
  ctaText?: string;
  isLoggedIn?: boolean;
  adminLink?: string;
  onEditProfileClick?: () => void;
}

const navItems = [
  { label: 'Domů', to: '/' },
  { label: 'Občerstvení', to: '/katalog' },
  { label: 'Aktivity a řemesla', to: '/aktivity' },
  { label: 'Novinky', to: '/novinky' },
  { label: 'Kontakt', to: '/kontakt' },
];

const MobileMenu = ({ ctaText = 'Přidat záznam', isLoggedIn, adminLink = '/admin', onEditProfileClick }: MobileMenuProps) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button className="lg:hidden text-white p-2 -mr-2">
          <span className="material-symbols-outlined text-2xl">menu</span>
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[300px] sm:w-[350px] p-0 bg-brand-dark border-l-0 flex flex-col [&>button]:text-white/50 [&>button:hover]:text-white">
        <SheetHeader className="p-6 border-b border-white/10">
          <SheetTitle className="sr-only">Menu</SheetTitle>
          <Link to="/" className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <svg className="w-full h-full" viewBox="0 0 100 100">
                <circle cx="50" cy="25" fill="#adff2f" r="12" />
                <circle cx="30" cy="55" fill="#e6fbff" r="12" />
                <circle cx="70" cy="55" fill="#fff0f6" r="12" />
              </svg>
            </div>
            <span className="text-lg font-extrabold tracking-tight text-white">
              PROFESTIVAL<span className="text-primary">.CZ</span>
            </span>
          </Link>
        </SheetHeader>

        <nav className="flex flex-col p-6 flex-1">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              className="py-4 text-lg font-semibold text-white/80 hover:text-primary transition-colors border-b border-white/10"
              activeClassName="text-primary"
            >
              {item.label}
            </NavLink>
          ))}

          <div className="mt-8 space-y-3">
            {isLoggedIn && (
              <Link
                to={adminLink}
                className="flex items-center justify-center gap-2 border border-white/20 text-white px-6 py-3 rounded-full font-bold text-sm uppercase tracking-tight hover:bg-white/10 transition-all w-full"
              >
                <span className="material-symbols-outlined text-base">admin_panel_settings</span>
                Admin
              </Link>
            )}
            {onEditProfileClick && (
              <button
                type="button"
                onClick={onEditProfileClick}
                className="flex items-center justify-center gap-2 border border-white/20 text-white px-6 py-3 rounded-full font-bold text-sm uppercase tracking-tight hover:bg-white/10 transition-all w-full"
              >
                <span className="material-symbols-outlined text-base">edit</span>
                Upravit profil
              </button>
            )}
            <a
              href="/pridat"
              className="flex items-center justify-center gap-2 bg-primary text-brand-dark px-6 py-3 rounded-full font-bold text-sm uppercase tracking-tight hover:shadow-lg hover:shadow-primary/20 transition-all w-full"
            >
              <span className="material-symbols-outlined text-base">add_circle</span>
              {ctaText}
            </a>
          </div>
        </nav>

        {/* Social Icons */}
        <div className="p-6 border-t border-white/10 flex justify-center gap-4">
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-white/60 hover:text-primary hover:bg-white/20 transition-all"
          >
            <Facebook className="w-5 h-5" />
          </a>
          <span
            role="img"
            aria-label="Instagram (připravujeme)"
            title="Instagram — připravujeme"
            className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-white/60 cursor-not-allowed"
          >
            <Instagram className="w-5 h-5" />
          </span>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;
